module.exports = __webpack_public_path__ + "assets/homepage-arrow-0231a7.svg";